import { Observable } from 'rxjs/Observable';
import { cloneDeep } from 'lodash';

Observable.prototype.cloneDeep = function () {
	return this.do(
		nextValue => {
			return cloneDeep(nextValue);
		}
	);
};

declare module 'rxjs/Observable' {
	interface Observable<T> {
		cloneDeep: (...any) => Observable<T>;
	}
}



// WEBPACK FOOTER //
// C:/Users/user/projects/ansyn/src/app/packages/core/utils/clone-deep.ts